// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderLanding_header__42yeX","main":"HeaderLanding_main__Ne_zr","mainContent":"HeaderLanding_mainContent__P7X9Y","rotation":"HeaderLanding_rotation__UjQcX"};